import MessagingBase from './messaging-base';

export default class MessagingProfile extends MessagingBase {
  // Overriding the default here as profile is a singleton endpoint
  // and doesn't follow the standard resource url patterns.
  pathForType() {
    return 'profile';
  }
}
